import { FieldName } from 'v2/core/entities/fields';
import { getMetadataKey } from 'v2/core/services/queryBuilder/whereClauseGenerator';

export function getFilterFieldFromFieldName(
  fieldName: FieldName | string,
): string {
  switch (fieldName) {
    case 'Entity':
      return 'entity';
    case 'Theme':
      return 'theme';
    case 'Reason':
      return 'reason';
    case 'EntitySentiment':
      return 'entitySentiment';
    case 'ReviewSentiment':
      return 'reviewSentiment';
    case 'Source':
      return 'source';
    case 'Language':
      return 'language';
    default:
      // metadata key
      return getMetadataKey(fieldName);
  }
}
